import { IMappingObjectData } from "../../types/common";
import { isDevelopmentEnv } from "./EnvironmentConstants";
import { allLocales, INDIA_LOCALES } from "./LocaleAndCountryConstants";

export const FACEBOOK_DOMAIN_VERIFICATION = {
    DEFAULT: "72iv9j8hobe5obgkw3sd26e17ggu3p",
};

export const META_DESC_CONTENT =
    "Download Bharat's Largest Real Cash gaming pro app to play fantasy sports, rummy, poker & 70  games. Play online games with 3 Crore  Players. ✓Win upto 10 Crore Daily ✓Withdraw Cash Instantly✓100%Safe & Secure";
export const META_KEYWORDS_CONTENT =
    "winzo, winzo gold, win, free cash, cricket, fantasy cricket, rummy, win cash";
export const PAGE_TITLE =
    "WinZO - Play Cricket, Rummy, Fantasy Sports & 70+ Games on India's Largest Real Cash Gaming App - Win Cash Daily!";

export const HOME_PAGE = "homePage";

// All Page URLs

export const HOME_PAGE_URL = "/";
export const GCEO_PATH = "gcoe";

// Other Pages URLS
export const CONTACT_US_URL = "contact-us";
export const NOT_FOUND_URL = "404";
export const SPINNER = "spinner";

// category pages url
export const COMMON = "common";
export const indiaLocaleObject: IMappingObjectData = {
    locales: INDIA_LOCALES,
};

export const pagesWithLocale = new Map<string, IMappingObjectData>([
    [HOME_PAGE_URL, { locales: allLocales }],
]);
export const USER_COUNTRY_CODE = "UCC";
export const DEVICE_MODEL = "dm";
export const CLOUDFRONT_USER_DETAILS = "ud";
export const COUNTRY_SELECTED_USING_POPUP = "COUNTRY_SELECTED";
export const NOT_FOUND = "NOT-FOUND";
export const INITIAL = "INITIAL";
export const NOT_IN_LIST = "NOT-IN-LIST";
export const TERMS_AND_CONDITION = "termsAndCondition" 
export const PRIVACY_POLICY = "privacyPolicy" 
export const GCOE_PRIVACY_POLICY = "gcoe/privacyPolicy" 

export const SECURITY_HEADERS = {
    "X-XSS-Protection": "1; mode=block",
    "X-Frame-Options": "DENY",
    "X-Content-Type-Options": "nosniff",
};

export const REQUEST_HEADERS = {
    CUSTOM_X_ORIGIN_LOCALE: "x-origin-locale",
    ACCEPT_LANGUAGE: "accept-language",
    CLOUDFRONT_VIEWER_COUNTRY: "cloudfront-viewer-country",
    CLOUDFRONT_IS_MOBILE_VIEWER: "cloudfront-is-mobile-viewer",
    USER_AGENT: "user-agent",
    REFERER: "referer",
    SEC_FETCH_SITE: "sec-fetch-site",
    SEC_CH_UA_MODEL: "Sec-CH-UA-Model",
    CLOUDFRONT_VIEWER_ADDRESS: "CloudFront-Viewer-Address",
    CLOUDFRONT_VIEWER_ASN: "CloudFront-Viewer-ASN",
    CLOUDFRONT_VIEWER_CITY: "CloudFront-Viewer-City",
    CLOUDFRONT_VIEWER_COUNTRY_NAME: "CloudFront-Viewer-Country-Name",
    CLOUDFRONT_VIEWER_COUNTRY_REGION: "CloudFront-Viewer-Country-Region",
    CLOUDFRONT_VIEWER_COUNTRY_REGION_NAME:
        "CloudFront-Viewer-Country-Region-Name",
    CLOUDFRONT_VIEWER_LATITUDE: "CloudFront-Viewer-Latitude",
    CLOUDFRONT_VIEWER_LONGITUDE: "CloudFront-Viewer-Longitude",
    CLOUDFRONT_VIEWER_METRO_CODE: "CloudFront-Viewer-Metro-Code",
    CLOUDFRONT_VIEWER_POSTAL_CODE: "CloudFront-Viewer-Postal-Code",
    CLOUDFRONT_VIEWER_TIME_ZONE: "CloudFront-Viewer-Time-Zone",
    X_HOST: "X-Host",
};

export const HEALTH_CHECKER = "HealthChecker";
export const REVALIDATE = isDevelopmentEnv ? 15 : 15 * 60;
export const CONTACT_US_FOLDER = "contact-us";
export const PITCH_US_FOLDER = "pitch-us"
export const GAME_DEV = "game-dev"
export const PRODUCT = "product"

export const LANDING_PAGE = "landing-page"
export const GAMESCOM_PAGE = "gamescom-page"
export const IGDC_PAGE = "IGDC"
export const GDC_PAGE = "GDC"
export const CONATCT_US_PAGE = "contact-us"
export const zoVentureslandingPage = "zoVenturesHome"
export const RAISE_FUNDS_PAGE = "raiseFunds"
export const OUR_PARTNERS_PAGE = "ourPartners"
export const ABOUT_US = "aboutUs"
export const GCOE_PAGE = "GCOE"

export const ABOUT_US_PAGE_PATH = "about-us";
export const GAMESCOM_PAGE_PATH = "gamescom";
export const GCOE_PAGE_PATH = "gcoe";
export const GDC_PAGE_PATH = "gdc";
export const ZOVENTURES_PAGE_PATH = "zoventures";
export const RAISE_FUNDS_PAGE_PATH = "raise-funds";
export const OUR_PARTNERS_PAGE_PATH = "our-partners";
export const GAME_DEV_PAGE_PATH = "game-dev";
export const PRODUCT_PAGE_PATH = "product";
export const PITCH_US_PAGE_PATH = "pitch-us";
export const CONTACT_US_PAGE_PATH = "contact-us";
export const LANDING_PAGE_PATH = "landing-page";
export const IGDC_PAGE_PATH = "igdc";
export const PRIVACY_POLICY_PAGE_PATH = "privacy-policy";
export const TERMS_AND_CONDITION_PAGE_PATH = "terms-and-conditions";
export const GCOE_PRIVACY_POLICY_PAGE_PATH = "gcoe/privacy-policy";

export const BASE_URL = 'https://business.winzogames.com';

export enum RaiseFundsAreaType {
    NONE = -1,
    GAME = 0,
    PRODUCT = 1
}

export enum VALIDATION_TYPE {
    EMAIL,
    LINK,
}

export enum FORM_TYPE {
    SELECT = "select",
    STRING = "text",
    NUMBER = "number",
    CHECKBOX = "checkbox"
}